import React, { useState, useEffect } from "react";
import Tab1Image from "../img/envision/aerospace/aerotabtwo/aerocybersecurity.jpg";
import Tab2Image from "../img/envision/aerospace/aerotabtwo/securityaero.jpg";
import Tab3Image from "../img/envision/aerospace/aerotabtwo/aeroplacecomplaines.jpg";
import Tab4Image from "../img/envision/aerospace/aero2banner.JPG";
import Tab5Image from "../img/envision/aerospace/tabsimages/[freepicdownloader.com]-generative-ai-military-fighter-jets-patrol-air-launch-missiles-medium.jpg";
import Tab6Image from "../img/envision/aerospace/tabsimages/jhkk.jpg";
import { useNavigate } from "react-router-dom";

const AerospaceSecondVerticaltab = () => {
    const [activeTab, setActiveTab] = useState("tab1");
    const [isAutoPlayActive, setIsAutoPlayActive] = useState(true); // State to manage autoplay

    // const handleTabClick = (tab) => setActiveTab(tab);

    const navigate = useNavigate(); // Initialize navigate

    const handleKnowMoreSecondClick = () => {
        navigate("/documentaerospacepage#AerospaceDoceumentSEeconddata");
    };

    const [isHovered, setIsHovered] = useState(false);

    // Autoplay effect to change tabs every 3 seconds (3000ms)
    useEffect(() => {
        let tabInterval;

        if (!isHovered && isAutoPlayActive) {
            tabInterval = setInterval(() => {
                setActiveTab((prevTab) => {
                    const nextTabNum = parseInt(prevTab.replace("tab", "")) % 3 + 1;
                    return `tab${nextTabNum}`;
                });
            }, 3000);
        }

        return () => clearInterval(tabInterval);
    }, [activeTab, isHovered, isAutoPlayActive]);


    const handleTabClick = (tabId) => {
        setActiveTab(tabId);
        setIsAutoPlayActive(false); // Stop auto-play when tab is clicked
    };

    const styles = {
        container: {
            fontFamily: "Arial, sans-serif",
            // display: "flex",
            flexDirection: "row",
            // width: "80%",
            margin: "50px auto",
            justifyContent: "space-between",
        },
        tabNav: {

            flexDirection: "column",
            borderRight: "1px solid #fff",
            // height: "350px",
            overflowY: "auto", // Ensure only vertical scrolling
            scrollbarWidth: "thin", // For Firefox
            scrollbarColor: "#ccc transparent", // For Firefox
        },
        // Apply mobile-specific styles for tabNav

        tabButton: {
            padding: "20px",
            cursor: "pointer",
            border: "none",
            background: "none",
            fontSize: "16px",
            fontWeight: "bold",
            color: "#555",
            outline: "none",
            transition: "color 0.3s, background-color 0.3s",
            borderRadius: "10px",
            margin: "5px 0",
            backgroundColor: "#f0f0f0",
        },
        activeTabButton: {
            backgroundColor: "rgb(236 115 34)",
            color: "#fff",
        },
        card: {

            alignItems: "center",
            padding: "20px",
            borderRadius: "15px",
            backgroundColor: "#fff",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
            width: "100%",
            marginLeft: "10px",
            cursor: "pointer",
            height: "400px",
            overflowY: "auto"
        },
        image: {
            width: "382px",
            height: "354px",
            borderRadius: "10px",
            marginRight: "20px",
        },
        textContent: {
            flex: 1,
            textAlign: "justify",
            color: "#333",
            marginTop: "110px",
            minHeight: "460px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",  // ✅ Change from space-between to flex-start
        },


        knowMoreButton: {
            marginTop: "15px",
            padding: "10px 20px",
            backgroundColor: "rgb(236 115 34)",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
            fontSize: "16px",
            transition: "background-color 0.3s",
            // marginLeft: "150px"
        },
        dotNav: {
            display: "flex",
            justifyContent: "center",
            marginTop: "10px",
        },
        dot: {
            width: "10px",
            height: "10px",
            borderRadius: "50%",
            backgroundColor: "#ccc",
            margin: "0 5px",
            cursor: "pointer",
            transition: "background-color 0.3s",
        },
        activeDot: {
            backgroundColor: "rgb(236 115 34)",
        },
        // Mobile styling for tabs above content
        mobileContainer: {
            flexDirection: "column", // Stack tabs and content
        },
        mobileTabNav: {
            flexDirection: "row", // Tabs are horizontal on mobile
            justifyContent: "space-around",
            borderRight: "none", // Remove right border for mobile
        },
        mobileCard: {
            flexDirection: "column", // Stack image and text content
            alignItems: "center",
            textAlign: "center",
        },
        mobileImage: {
            width: "100%",
            height: "auto",
            marginRight: "0", // Remove right margin on mobile
        },
        mobileKnowMoreButton: {
            marginLeft: "0", // Center button on mobile
        },
        // Mobile tab navigation change
        mobileTabButton: {
            padding: "20px",
            fontSize: "14px",
            fontWeight: "normal",
            color: "#555",
            backgroundColor: "#f0f0f0",
            border: "none",
            cursor: "pointer",
            outline: "none",
            textAlign: "center",
        },
        activeMobileTabButton: {
            backgroundColor: "rgb(236 115 34)",
            color: "#fff",
        },

    };

    return (
        <div style={{ marginTop: '100px' }}>
            <h1 style={{ textAlign: "center" }}>
                <span style={{ color: "rgb(236 115 34)" }}> Integrated (ISO-PCI) </span>  Compliance services
            </h1>

            <div style={{ ...styles.container, ...(window.innerWidth <= 768 ? styles.mobileContainer : {}) }} className="tabclass-container-data">
                {/* Tab Navigation */}
                <div style={{ ...styles.tabNav, ...(window.innerWidth <= 768 ? styles.mobileTabNav : {}) }} className="tabdata-aero-second">
                    <button
                        style={{
                            ...styles.tabButton,
                            ...(window.innerWidth <= 768 ? styles.mobileTabButton : {}),
                            ...(activeTab === "tab1" ? styles.activeTabButton : {}),
                        }}
                        onClick={() => handleTabClick("tab1")}
                        className="tab-button-width"
                        onMouseEnter={(e) => {
                            if (activeTab !== "tab1") {
                                e.currentTarget.style.backgroundColor = "#000"; // Change background to black
                                e.currentTarget.style.color = "#fff"; // Change text to white
                            }
                        }}
                        onMouseLeave={(e) => {
                            if (activeTab !== "tab1") {
                                e.currentTarget.style.backgroundColor = ""; // Revert background
                                e.currentTarget.style.color = ""; // Revert text color
                            }
                        }}
                    >
                        Cybersecurity & IT Systems in standards
                    </button>
                    <button
                        style={{
                            ...styles.tabButton,
                            ...(window.innerWidth <= 768 ? styles.mobileTabButton : {}),
                            ...(activeTab === "tab2" ? styles.activeTabButton : {}),
                        }}
                        onClick={() => handleTabClick("tab2")}
                        className="tab-button-width"
                        onMouseEnter={(e) => {
                            if (activeTab !== "tab2") {
                                e.currentTarget.style.backgroundColor = "#000"; // Change background to black
                                e.currentTarget.style.color = "#fff"; // Change text to white
                            }
                        }}
                        onMouseLeave={(e) => {
                            if (activeTab !== "tab2") {
                                e.currentTarget.style.backgroundColor = ""; // Revert background
                                e.currentTarget.style.color = ""; // Revert text color
                            }
                        }}
                    >
                        Aerospace Supply Chain & Risk Management standards
                    </button>
                    <button
                        style={{
                            ...styles.tabButton,
                            ...(window.innerWidth <= 768 ? styles.mobileTabButton : {}),
                            ...(activeTab === "tab3" ? styles.activeTabButton : {}),
                        }}
                        onClick={() => handleTabClick("tab3")}
                        className="tab-button-width"
                        onMouseEnter={(e) => {
                            if (activeTab !== "tab3") {
                                e.currentTarget.style.backgroundColor = "#000"; // Change background to black
                                e.currentTarget.style.color = "#fff"; // Change text to white
                            }
                        }}
                        onMouseLeave={(e) => {
                            if (activeTab !== "tab3") {
                                e.currentTarget.style.backgroundColor = ""; // Revert background
                                e.currentTarget.style.color = ""; // Revert text color
                            }
                        }}
                    >
                        Aerospace Compliance & Quality Standards
                    </button>
                </div>

                {/* Tab Content */}
                <div style={{ ...styles.card, ...(window.innerWidth <= 768 ? styles.mobileCard : {}) }}
                    className="tabclass-container-data"
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                >
                    <img
                        src={{ tab1: Tab1Image, tab2: Tab2Image, tab3: Tab3Image }[activeTab]}
                        alt="Aerospace"
                        style={{ ...styles.image, ...(window.innerWidth <= 768 ? styles.mobileImage : {}) }}
                    />

                    <div style={styles.textContent}>
                        {(() => {
                            const tabIndex = parseInt(activeTab.replace("tab", "")) - 1;
                            const contentArray = [
                                [
                                    "ISO/IEC 27001 – Information security management for aerospace IT infrastructure.",
                                    "ISO/IEC 27002 – Security controls for protecting aerospace data.",
                                    "ISO/IEC 27701 – Privacy information management for handling sensitive aerospace data.",
                                    "ISO/IEC 62443 – Cybersecurity for industrial automation & control systems (IACS) in aerospace manufacturing.",
                                    "NIST SP 800-171 / CMMC – Cybersecurity standards for aerospace defense contractors (U.S. DoD compliance)."
                                ],
                                [
                                    "ISO 28000 – Supply chain security risk management for aerospace manufacturers & suppliers.",
                                    "ISO 22301 – Business continuity management for aerospace companies & airports.",
                                    "ISO 31000 – Risk management framework for aerospace supply chains.",
                                    "ISO 55001 – Asset management for aircraft, spacecraft, and aerospace infrastructure.",
                                    "SAE AS5553 – Counterfeit electronic parts prevention in aerospace supply chains."
                                ],
                                [
                                    "AS9100 – Quality management system for aerospace manufacturers.",
                                    "NADCAP – Aerospace industry accreditation program for manufacturing processes.",
                                    "FAA Part 21 – Certification procedures for aerospace products & parts.",
                                    "EASA Part 145 – Maintenance organization approval for aerospace compliance.",
                                    "ISO 9001 – General quality management standard for aerospace suppliers."
                                ]
                            ];

                            const selectedContent = contentArray[tabIndex] || [];

                            return (
                                <div>
                                    {/* Render text content with bullet points */}
                                    <ul style={{ paddingLeft: "20px", margin: 0, listStyleType: "disc" }}>
                                        {selectedContent.map((point, index) => (
                                            <li key={index} style={{ marginBottom: "5px" }}>{point}</li>
                                        ))}
                                    </ul>

                                    {/* Separate "Know More" button for each tab */}
                                    <button
                                        style={{
                                            ...styles.knowMoreButton,
                                            ...(window.innerWidth <= 768 ? styles.mobileKnowMoreButton : {}),
                                            marginTop: "10px", // Space between text & button
                                            display: "block", // Ensures full-width behavior if needed
                                        }}
                                        className="know-more-btn"
                                        onClick={() => handleKnowMoreSecondClick(activeTab)}
                                    >
                                        Know More
                                    </button>
                                </div>
                            );
                        })()}
                    </div>

                </div>

            </div>

            {/* Dot Navigation for 3 Tabs */}
            <div style={styles.dotNav}>
                {[...Array(3)].map((_, index) => {
                    const tab = `tab${index + 1}`;
                    return (
                        <div
                            key={tab}
                            style={{
                                ...styles.dot,
                                ...(activeTab === tab ? styles.activeDot : {}),
                            }}
                            onClick={() => handleTabClick(tab)}
                        />
                    );
                })}
            </div>
        </div>
    );
};

export default AerospaceSecondVerticaltab;
